import { ArrowRight, MessageCircle } from "lucide-react";
import { genericWhatsAppLink } from "../lib/api";

export default function StickyCtas({ onBook }) {
  return (
    <>
      {/* Mobile sticky bottom bar */}
      <div className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-[#070A08]/95 backdrop-blur-md border-t border-[#17231B] px-4 py-3 flex gap-3" data-testid="mobile-sticky-bar">
        <button
          onClick={onBook}
          data-testid="sticky-book-button"
          className="flex-1 inline-flex items-center justify-center gap-2 rounded-full bg-[#22C55E] text-[#04100A] font-extrabold text-sm px-4 py-3.5"
        >
          Inquire Now <ArrowRight className="w-4 h-4" />
        </button>
        <a
          href={genericWhatsAppLink()}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Chat on WhatsApp"
          data-testid="sticky-whatsapp-button"
          className="w-12 h-12 rounded-full border border-[#22C55E]/40 flex items-center justify-center text-[#22C55E]"
        >
          <MessageCircle className="w-5 h-5" />
        </a>
      </div>
      {/* Desktop floating WhatsApp */}
      <a
        href={genericWhatsAppLink()}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
        data-testid="floating-whatsapp-button"
        className="hidden md:flex fixed bottom-8 right-8 z-40 w-14 h-14 rounded-full bg-[#22C55E] items-center justify-center text-[#04100A] shadow-[0_0_35px_-6px_rgba(34,197,94,0.7)] hover:scale-105 transition-transform whatsapp-pulse"
      >
        <MessageCircle className="w-6 h-6" />
      </a>
    </>
  );
}
